:host {
  @apply w-full inline-flex flex-col items-start gap-2.5 px-0 py-5 rounded-lg bg-primary;
}

.frame {
  @apply w-full flex flex-col items-start gap-6 px-5 py-0 bg-primary;
}

.name {
  @apply text-on text-2xl not-italic font-semibold leading-[20.5px] tracking-[-0.5px];
}

.heading {
  @apply flex text-on text-xl not-italic font-semibold items-center gap-2;
}

/* .info {
  @apply flex flex-col items-start gap-2;
} */

.short-description {
  @apply text-on text-base not-italic font-medium leading-[20.5px] tracking-[-0.5px];
}

.details {
  @apply flex flex-col items-start gap-4;
}

.long-description {
  @apply text-on-alt text-xs not-italic font-normal leading-[150%] tracking-[-0.5px];
}
.issuer {
  @apply self-stretch overflow-hidden text-on text-ellipsis text-xs not-italic font-normal leading-4;
}
